import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import ManagerAddNew from "../managerAddNew/ManagerAddNew";
import {RouteHelper} from "../../route/RouteHelper";
import {useNavigate} from "react-router-dom";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {Helmet} from "react-helmet";
import {
    convertUniversalDateTimeToPersianDateTime,
    DialogSize, RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoTableTitleContainer,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";

let selectedItemID = -1

const ManagersList = () => {
    let page = 0;
    const size = 15

    const navigate = useNavigate()

    const service = new ManagerService()

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [isNeedRefresh, setIsNeedRefresh] = useState(false);


    useEffect(() => {
        if (service) {
            getManagerListFromServer()
        }
    }, [])


    const [openDialog, setOpenDialog] = useState(false)
    const [loadingManagerTable, setLoadingManagerTable] = useState(false)
    const [managerList, setManagerList] = useState([])
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0)

    function handleAddNewManager() {
        selectedItemID = -1
        setOpenDialog(true)

    }

    function getManagerListFromServer() {
        setLoadingManagerTable(true)
        service.getManagerList(page, size)
            .then(response => {
                setLoadingManagerTable(false)
                setPageCount(response.totalPage)
                setTotalItems(response.numberOfItems)

                setManagerList([])
                response.data.map((item, index) => {
                    setManagerList(prevState => [
                        ...prevState,
                        prepareManagerListRow(
                            (page * size) + index + 1,
                            item.id,
                            item.firstName,
                            item.lastName,
                            item.username,
                            item.phoneNumber,
                            item.createdAt,
                            item.createdBy,
                        )
                    ])
                })

            }).catch(reason => {
            showErrorMessage(new ServerErrorHandler(reason).getMessage())
            setLoadingManagerTable(false)
        })
    }

    function prepareManagerListRow(number, id, firstName, lastName, username, phoneNumber, createdAt, createdBy) {
        return {
            number,
            id,
            fullName: `${firstName} ${lastName}`,
            userName: username,
            phoneNumber: phoneNumber,
            createdAt: createdAt ? convertUniversalDateTimeToPersianDateTime(createdAt) : "نامشخص",
            createdBy: createdBy,
        }
    }

    function handlePagination(value) {
        page = value
        getManagerListFromServer()
    }

    function handleShowManagerInfo(rowId) {
        navigate(`${RouteHelper.ManagersDetail.globalUrl.replace(":id", rowId)}`)
    }

    function handleCloseManagerInfo() {
        setOpenDialog(false)
        if (isNeedRefresh) {
            page = 0
            getManagerListFromServer()
            setIsNeedRefresh(false)
        }
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseManagerInfo}
                open={openDialog}
                dialogSize={DialogSize.LARGE}
                pageTitle={"افزودن مدیر جدید"}
            >
                <ManagerAddNew changeNeedRefresh={setIsNeedRefresh}/>
            </RaikoDefaultDialogPage>
            <Helmet>
                <title>{RouteHelper.ManagersList.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "مدیریت",
                                RouteHelper.ManagersList.url
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.ManagersList.name,
                                ""
                            ),
                        ]}/>

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"مدیران"}
                                hasCreateNewItem
                                handleCreateNewItem={handleAddNewManager}
                                amount={totalItems}
                            />
                            <RaikoCustomTable
                                isLoading={loadingManagerTable}
                                data={managerList}
                                header={column}
                                pageCount={pageCount}
                                handlePaginationChange={handlePagination}
                                rowClicked={handleShowManagerInfo}/>
                        </RaikoGridOneColumn>

                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>


        </>
    )
}
export default ManagersList;
const column = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
    },
    {
        id: 'userName',
        label: 'نام کاربری'
    },
    {
        id: 'phoneNumber',
        label: 'شماره همراه',
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
]